/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * HyusnSu Sim (hssim@rsupport.com)
 *
 * @description
 *
 * @created at Thu Mar 23 2023
 **/

import { css } from "@emotion/react";
import type { Theme } from "@emotion/react";

export const wrapperStyle = (theme: Theme) => {
	return css`
		position: relative;
		display: flex;
		color: ${theme.colors.primary_90_100};
		flex-direction: column;
	`;
};
export const selectStyle = (theme: Theme, outlined: boolean) => {
	return outlined
		? css`
				cursor: pointer;
				border: none;
				&:hover {
					background: ${theme.colors.secondary_80_8};
					border: none;
				}
				&:focus {
					background: none;
					border: none;
				}
			`
		: css`
				cursor: pointer;
			`;
};

export const layerStyle = (width: UnitString = "100%", maxHeight: UnitString = "300px") => {
	return css`
		width: ${width};
		padding: 8px;
		background: #fcfcfc;
		overflow: hidden;
		transition: opacity 0.25s ease-in-out;
		flex-direction: column;
		align-items: flex-start;
		box-sizing: border-box;
		text-align: left;
		border-radius: 8px;
		box-shadow: rgb(0 0 0 / 16%) 0px 4px 16px;
		max-height: ${maxHeight};
		overflow-y: auto;
		z-index: 1;
	`;
};

export const selectOptionStyle = (theme: Theme) => css`
	width: 100%;
	padding: 5px 10px;
	background: ${theme.colors.neutral_00_100};
	padding: 6px, 8px, 6px, 8px;
	border-radius: 8px;
	cursor: pointer;

	&:hover {
		background: ${theme.colors.secondary_80_8};
	}
`;

export const subLabelStyle = (theme: Theme) => css`
	width: 100%;
	font-size: 12px;
	color: ${theme.colors.neutral_60_100};
	background: ${theme.colors.neutral_00_100};
	padding: 2px 4px;
`;
